export default {
  text: '#232323',
  primary: '#f0662b',
  secondary: '#ede8e0',
  background: 'white',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
